import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {SearchFilter} from '@app/core/services/search/search-filter.interface'

import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '../generic-list.service'
import {
  UserService,
  User,
  GetUsersRequest,
} from '@app/core/services/user/user.service'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'
export interface UserRequest extends LoadRequest {
  query: string
  sortField: string
  sortAsc: boolean
}

@Injectable()
export class UserListService extends GenericListService<User> {
  filter: SearchFilter = null

  constructor(
    private userSvc: UserService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<User>> {
    // build the service request
    const svcRequest: GetUsersRequest = {
      domain: request.domain,
      offset: request.offset,
      results: request.count,
    }

    if (this.filter) {
      svcRequest.search = this.filter.query
      svcRequest.sort = this.filter.sort
      svcRequest.asc = this.filter.asc
    }

    return this.userSvc.getUsers(svcRequest).pipe(
      map((res) => {
        const result: LoadResult<User> = {
          total: res.count,
          items: res.results,
        }
        return result
      }),
    )
  }
}
